module.exports = __webpack_public_path__ + "static/media/fan.46690189.svg";